<template>
    <div class="mx-3">
        <dispute-dates-modal></dispute-dates-modal>
        <document-tags></document-tags>
        <compensation-dispute-list-filters-modal></compensation-dispute-list-filters-modal>

        <div v-if="clients.length === 1" class="h4">
            {{ clientName }}
        </div>
        <div v-else class="dropdown h4">
            <a id="clientDropdown" class="dropdown-toggle" href="#" role="button" data-toggle="dropdown">
                {{ clientName }}
            </a>
            <div class="dropdown-menu dropdown-menu-right">
                <button :key="'client-dropdown-menu-item-0'" class="h5 dropdown-item" @click="changeClient(0)">All Clients</button>
                <button v-for="client in clients" :key="'client-dropdown-menu-item-' + client.id" class="h5 dropdown-item" @click="changeClient(client.id)">{{ client.name }}</button>
            </div>
        </div>
        <div class="d-flex justify-content-between align-items-end">
            <div>
                <h2>
                    Compensation Disputes
                    <span class="h2-italic-sm text-muted">(LWC Form 1008)</span>
                </h2>
            </div>
            <div class="btn-toolbar mb-2" role="toolbar">
                <div class="input-group mr-2">
                    <div class="input-group-prepend">
                        <button class="btn dropdown-toggle input-group-text" type="button" data-toggle="dropdown">{{ searchOption.name }}</button>
                        <div class="dropdown-menu">
                            <button v-for="option in searchOptions" :key="'search-option-' + option.id" class="dropdown-item text-primary" @click="setSearchOption(option)">{{ option.name }}</button>
                        </div>
                    </div>                    
                    <input ref="searchInput" type="text" class="form-control" :placeholder="searchOption.placeholder" v-model="searchString" @keyup.enter="search()">
                    <div class="input-group-append">
                        <button class="btn btn-primary" @click="search()"><i class="fas fa-search fa-lg"></i></button>
                    </div>                    
                </div>
                <div class="btn-group">
                    <button class="btn btn-primary" data-toggle="tooltip" title="Filters" @click="showFilters()">
                        <i class="fas fa-filter fa-lg"></i>                   
                    </button>
                </div>                
            </div>
        </div>

        <div v-if="documents.length" class="table-responsive">
            <table class="table table-striped table-sm">
                <thead>
                    <tr>
                        <th></th>
                        <th class="fit pr-3">Docket Number</th>
                        <th class="fit pr-3">Patient Name</th>
                        <th>Description</th>
                        <th class="fit">Owner</th>
                        <th class="fit pr-3">Uploaded/Created</th>
                        <th class="fit pr-3">Milestone</th>
                        <th class="fit">Tags</th>
                        <th class="fit"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="doc in documents" :key="'legal-dispute-list-' + doc.id">
                        <td></td>
                        <td class="fit pr-3">
                            <input v-if="doc.editDocketNumber" type="text" class="form-control form-control-sm" v-model="doc.docket_number" @blur="changeDocketNumber(doc)" @keyup.enter="changeDocketNumber(doc)" v-focus>
                            <span v-else @click="$set(doc, 'editDocketNumber', true)">
                                <span v-if="doc.docket_number">{{ doc.docket_number }}</span>
                                <span v-else class="font-italic text-muted">Docket Number</span>
                                <a href="javascript:void(0)" class="edit-button"><i class="fas fa-pencil-alt fa-xs"></i></a>
                            </span>                            
                        </td>
                        <td class="fit pr-3"><a :href="getClaimHref(doc)">{{ doc.patient_name }}</a></td>
                        <td>
                            <!-- <input v-if="doc.editDescription" type="text" class="form-control form-control-sm" v-model="doc.description" @blur="changeDescription(doc)" @keyup.enter="changeDescription(doc)" v-focus>
                            <span v-else @click="$set(doc, 'editDescription', true)" :title="doc.description">                              -->
                                {{ doc.description | truncate(80) }}
                                <!-- <a href="javascript:void(0)" class="edit-button"><i class="fas fa-pencil-alt fa-xs"></i></a>
                            </span>                             -->
                        </td>
                        <td class="fit">{{ doc.owner }}</td>
                        <td class="fit pr-3">{{ doc.created_at | localizeTime('YYYY-MM-DD HH:mm:ss') }}</td>
                        <td class="fit pr-3">{{ milestone(doc) }}</td>
                        <td><document-tags-button :document="doc"></document-tags-button></td>
                        <td class="fit">
                            <div class="d-flex flex-nowrap flex-row justify-content-end">

                                <div class="flex-fill text-center">
                                    <a v-if="doc.packet_exists && doc.can_edit" :href="'/attorney/claims/' + doc.claim_id + '/disputes/' + doc.id + '?force=true'" class="btn btn-link btn-sm py-0 px-1" title="Edit Form 1008">
                                        <i class="fas fa-edit fa-lg"></i>
                                    </a>
                                    <div v-else class="py-0 px-1">
                                        <i class="fas fa-edit fa-lg fa-fw icon-hidden"></i>
                                    </div>
                                </div>

                                <div class="flex-fill text-center">
                                    <button class="btn btn-link btn-sm py-0 px-1" @click="showDates(doc)">
                                        <i class="fas fa-calendar fa-lg"></i>
                                    </button>
                                </div>
                            </div>                        
                        </td>                     
                    </tr>
                </tbody>
            </table>
            <div class="d-flex">
                <nav v-if="pageCount > 1" aria-label="Page navigation">
                    <ul class="pagination">
                        <li v-bind:class="['page-item', { 'disabled' : currentPage == 1 }]">
                            <a class="page-link" href="#" @click="first()">
                                <span id="first-page"><i class="fas fa-step-backward fa-xs chev-pos"></i></span>
                            </a>
                        </li>                        
                        <li v-bind:class="['page-item', { 'disabled' : currentPage == 1 }]">
                            <a class="page-link" href="#" @click="previous()">
                                <span id="previous"><i class="fas fa-chevron-left fa-xs chev-pos"></i><i class="fas fa-chevron-left fa-xs mr-1 chev-pos"></i>Previous</span>
                            </a>
                        </li>
                        <li v-bind:class="['page-item', { 'disabled' : currentPage == pageCount }]">
                            <a class="page-link" href="#" @click="next()">
                                <span id="next">Next<i class="fas fa-chevron-right fa-xs ml-2 chev-pos"></i><i class="fas fa-chevron-right fa-xs chev-pos"></i></span>
                            </a>
                        </li>
                        <li v-bind:class="['page-item', { 'disabled' : currentPage == pageCount }]">
                            <a class="page-link" href="#" @click="last()">
                                <span id="first-page"><i class="fas fa-step-forward fa-xs chev-pos"></i></span>
                            </a>
                        </li>                        
                    </ul>
                </nav>
                <div class="ml-auto"> Page {{ currentPage }} of {{ pageCount }}</div>
            </div>            
        </div>
        <div v-else-if="isLoading" class="pt-3 border-top">            
            <h3 class="text-muted text-center"><i class="fas fa-spinner fa-lg fa-spin align-middle"></i> Loading...</h3>
        </div>
        <div v-else class="pt-3 border-top">
            <h4 class="text-muted text-center">No Compensation Dispute (LWC 1008) documents.</h4>
        </div>
    </div>
</template>

<script>
import DisputeDatesModal from './AttorneyDisputeDatesComponent.vue';
import DocumentTags from '../documents/DocumentTagsComponent.vue';
import DocumentTagsButton from '../buttons/DocumentTagsButtonComponent.vue';
import CompensationDisputeListFiltersModal from './Attorney1008ListFiltersComponent.vue';

export default {
    components: {
        DisputeDatesModal,
        DocumentTags,
        DocumentTagsButton,
        CompensationDisputeListFiltersModal
    },
    props: {
        clients: Array,
        clientIdProperty: Number,
        pageProperty: Number,
        searchOptions: Array,
        searchOptionId: Number,        
        searchStringProperty: String,
        filtersProperty: Object              
    },
    data() {
        return {
            isLoading: false,
            clientId: this.clientIdProperty,
            documents: [],
            pageCount: 0,
            currentPage: this.pageProperty,
            searchOption: this.searchOptions.find(x => x.id === this.searchOptionId),
            searchString: this.searchStringProperty,          
            filters: this.filtersProperty,
            channels: []
        }
    },
    computed: {
        clientName: function () {
            return this.clientId ? this.clients.find(x => x.id == this.clientId).name : 'All Clients';
        }
    },
    methods: {
        refresh: function () {

            this.isLoading = true;
            axios.get('/ajax/attorney/clients/' + this.clientId + '/legal-disputes', {
                params: {
                    search_option_id: this.searchOption.id,
                    search_string: this.searchString,                    
                    page: this.currentPage,                    
                    filters: this.filters
                }
            })
            .then(response => {
                this.documents = response.data.documents;
                this.pageCount = response.data.page_count;
                this.isLoading = false;
            })
            .catch(error => {
                console.log('got an error...');
                this.isLoading = false;
            });
        },
        changeClient: function (id) {
            this.clientId = id;
            this.currentPage = 1;
            this.refresh();            
        },
        first: function () {
            if (this.currentPage > 1) {
                this.currentPage = 1;
                this.refresh();
            }
        },        
        previous: function() {
            if (this.currentPage > 0) {
                this.currentPage--;
                this.refresh();
            }
        },
        next: function() {
            if (this.currentPage < this.pageCount) {
                this.currentPage++;
                this.refresh();
            }
        },
        last: function () {
            if (this.currentPage < this.pageCount) {
                this.currentPage = this.pageCount;
                this.refresh();
            }
        },
        setSearchOption: function (option) {
            this.searchOption = option;
        },
        search: function () {
            this.currentPage = 1;
            this.refresh();
        },
        showFilters: function () {
            eventHub.$emit('show-compensation-dispute-list-filters', this.filters, this.filter);
        },
        filter: function (filters) {
            this.filters = filters;
            this.refresh();
        },
        changeDescription: function (document) {

            document.editDescription = false;

            // update the model
            this.$emit('update');

            // send the change to the server
            axios.patch('/ajax/attorney/documents/' + document.id + '/description', {
                'description': document.description,
            });            
        },
        changeDocketNumber: function (document) {
            document.editDocketNumber = false;
            this.$emit('update');

            // send the change to the server
            axios.patch('/ajax/attorney/documents/' + document.id + '/docket', {
                'docket_number': document.docket_number,
            });
        },                
        generate: function (doc) {
            doc.generating = true;
            axios.post('/ajax/attorney/claims/' + doc.claim_id + '/disputes/' + doc.id + '/generate', {})
                .then(response => {
                    toastr['success'](response.data.message, 'Generating 1008 Packet', { timeOut: 10000, positionClass: "toast-top-full-width", closeButton: true });
                })
                .catch(error =>  {
                    doc.generating = false;
                    toastr['error'](error.response.data.message, 'Error', { timeOut: 10000, positionClass: "toast-top-full-width", closeButton: true });
                });            
        },
        showDates: function (doc) {
            eventHub.$emit('show-attorney-dispute-dates', doc);
        },        
        milestone: function (doc) {

            let retval = null;

            if (doc.filing_date) {
                retval = 'Filed - ' + doc.filing_date;
            }

            if (doc.trial_setting_conference_date) {
                retval = 'TSC - ' + doc.trial_setting_conference_date;
            }

            if (doc.trial_date) {
                retval = 'Trial - ' + doc.trial_date;
            }
            
            if (doc.dismissal_date) {
                retval = 'Dismissed - ' + doc.dismissal_date;
            }
            else if (doc.settlement_date) {
                retval = 'Settled - ' + doc.settlement_date;
            }        
            else if (doc.closing_date) {
                retval = 'Closed - ' + doc.closing_date;
            }

            return retval;
        },
        getClaimHref: function (document) {

            let url = new URL(window.location.origin + `/attorney/claims/${document.claim_id}`);

            url.searchParams.append('clientId', this.clientId);
            url.searchParams.append('searchOptionId', this.searchOption.id);
            url.searchParams.append('searchString', this.searchString);
            url.searchParams.append('page', this.currentPage);
            url.searchParams.append('filters', JSON.stringify(this.filters));

            return url;
        },
        setChannelNames: function () {

            // clear the array
            this.channels = [];        

            if (this.clientId == 0) {

                // create a channel for each client
                var self = this;
                this.clients.forEach(element => {
                    self.channels.push(`document-tags-event.document.${element.id}`);
                });
            }
            else if (this.clientId > 0) {

                // create a channel for the selected client
                this.channels.push(`document-tags-event.document.${this.clientId}`);
            }
        },        
        listen: function () {

            var self = this;

            // leave all channels
            self.channels.forEach(channel => { window.Echo.leave(channel); });          
            
            // reset the channel names base on the selected client
            self.setChannelNames();               

            // listen on all required channels
            self.channels.forEach(channel => {

                window.Echo.private(channel)
                    .listen('DocumentTagsEvent', (e) => {
                        let document = this.documents.find(d => d.id === e.id);
                        if (document) {
                            this.$set(document, 'tags', e.tags);
                        }                  
                    });
            }); 
        }                           
    },
    created() {
        
        this.refresh();

        if (!this.clientId && this.clients.length === 1) {
            this.clientId = this.clients[0].id;
        }
        
        this.listen();      
    },
    mounted() {        
        this.$refs.searchInput.setAttribute('size', this.$refs.searchInput.getAttribute('placeholder').length);
    },
    directives: {
        focus: {
            inserted: function (el) {
                el.focus();
            }
        }
    }           
}
</script>

<style scoped>
    .h2-italic-sm {
        font-size: .50em !important;
        font-style: italic !important; 
        font-weight: normal !important;    
    }

    td {
        white-space: nowrap;
    }

    .fa-tags {
        font-size: 1.2em;
    }
    
    .icon-hidden {
       color: transparent; 
    }    
</style>